export enum MedicinalProductSearchMode {
    SUKL_CODE = "SUKL_CODE",
    REGISTRATION_NUMBER = "REGISTRATION_NUMBER"
}